import type { IObjectiveProductRequirements } from './ObjectiveProductRequirements.interface';
import ObjectiveProductRequirementsAssetFinance from './ObjectiveProductRequirementsAssetFinance';

export default class ObjectiveProductRequirements implements IObjectiveProductRequirements {
  assetFinance: ObjectiveProductRequirementsAssetFinance;

  static build = (data: IObjectiveProductRequirements) =>
    new ObjectiveProductRequirements(data);

  static blank = () => new ObjectiveProductRequirements();

  /**
   * Constructor
   * @param {IObjectiveProductRequirements} data
   */
  constructor(data?: IObjectiveProductRequirements) {
    this.assetFinance = new ObjectiveProductRequirementsAssetFinance(data?.assetFinance);
  }
}
